export default __webpack_public_path__ + "static/media/ExternalAuth-documentation.6201c430.md";